/** The time format the API stores and the `TimePicker` renders. */
export const SENDING_TIME_FORMAT = 'HH:mm';

/** UI-only discriminator; the API encodes it as email_type ('' = marketing). */
export const KIND = {
  TRANSACTIONAL: 'transactional',
  MARKETING: 'marketing',
} as const;

/**
 * What step 1 of creating has to be happy with before the editor opens.
 *
 * Listed rather than "everything except body", because `validateFields()` with no
 * argument validates `body` too — and `body` is necessarily empty here, so the
 * step could never be passed.
 */
export const CREATE_STEP_FIELDS = [
  'name',
  'kind',
  'email_type',
  'journey_hash_id',
  'subject',
  'pretext',
];
